import styled from 'styled-components';

export const VestingCardStyles = styled.div<{ disabled?: boolean }>`
	display: flex;
	flex-direction: column;
	padding: 1rem 0.5rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 5px;
	background: #f7f9fa;

	.title {
		&.disabled {
			opacity: 0.6;
		}
	}
`;
